export default [{"url":"https://zeddhubs-0.api.invexerp.io","name":"Branch 1","port":"6528","isStore":true,"isHQ":true}]